var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 12 12","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.118 8.793L7.41 9.5 3.875 5.964 7.411 2.43l.707.707-2.829 2.828 2.829 2.829z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }